import { ContactUs, CopyrightFooter, DataGrid, DataSource } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import { getUserActivityDataSource } from 'app/containers/UserActivity/DataSource';
import * as React from 'react';

interface IUserActivityState {
  usernameSearch: string,
  isLoggedIn: boolean,
  username: string,
  key: string,
  userActivityDataSource: DataSource<any>
}

class UserActivity extends Container<{}, IUserActivityState> {

  componentWillMount() {
    super.componentWillMount()
  }

  componentDidMount() {

  }

  mapAppStateToContainerState(appState: IAppState) {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    const key = appState.User.token
    //NOTE: Will update whenever the app updates. May not want that to happen in the future.
    const userActivityDataSource = getUserActivityDataSource(key)
    return { usernameSearch: '', isLoggedIn, username, key, userActivityDataSource }
  }

  render() {
    return (
      <section>
        <section className="container padding-top-lg">
          <h3 style={{ marginTop: 0 }}>FoundationMark User Activity</h3>
          <DataGrid DataSource={this.state.userActivityDataSource}
            pageSizes={[10, 15]}
            columns={[
              { label: 'User', pathExpression: '$.userName' },
              { label: 'IP Address', pathExpression: '$.ip_address' },
              { label: 'Action', pathExpression: '$.action' },
              { label: 'Message', pathExpression: '$.message' },
              { label: 'Action Date', pathExpression: '$.activityDate' },
            ]}
          />
        </section>

        <CopyrightFooter />
      </section>
    )
  }
}

export {
  UserActivity
}



// WEBPACK FOOTER //
// ./src/app/containers/UserActivity/index.tsx